import { Button, ButtonProps } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface Props extends ButtonProps {
  disabled?: boolean;
  href?: string;
  icon?: any;
}

export const SidebarLink = (props: Props) => {
  const { children, href, ...buttonProps } = props;
  return (
    <Button
      disabled={props.disabled}
      fontSize='lg'
      variant='ghost'
      width='full'
      justifyContent='start'
      gap='3'
      color='fg.muted'
      _hover={{
        bg: 'colorPalette.subtle',
        color: 'colorPalette.fg'
      }}
      _currentPage={{
        color: 'colorPalette.fg',
        textDecoration: 'underline'
      }}
      asChild
      {...buttonProps}>
      <a href={href}>
        {<FontAwesomeIcon icon={props.icon} />}
        {children}
      </a>
    </Button>
  );
};
